<div class="chat-container" (keydown)="handleKeyEvents($event)">
  <!-- Chat Header -->
  <div class="chat-header " [@slideStatus]="status"  >
    <h2 class="header-text">AI Assistant</h2>
    <p class="description-text">Type your query below and press send.</p>
    <div class="notification"  [@slideStatus]="status"   *ngIf="notification">
      {{ notification }}
    </div>
  </div>
  <!-- Messages -->
  <div class="chat-message-scroller" >
    <div
      class="message-wrapper"
      *ngFor="let msg of visibleMessages"
      [ngClass]="{'float-end': msg.role.toString() === 'User' }"
    >

    <small class="fw-lighter"  >{{ msg.role }}</small>
    <hr class="my-2"/>
     <!-- divider -->
     <!-- Using ngx-markdown for rendering markdown content -->
      <ng-container *ngIf="msg.role.toString() === 'Assistant'; else userMessage">
        <!-- if Assistent -->


        <!-- If you're using Markdown: -->
        <markdown    [data]="msg.displayedMessage ? msg.displayedMessage : msg.message"></markdown>
        <!-- Explanation:
             We first try to show displayedMessage iSf it exists,
             otherwise fallback to msg.message (e.g., older messages that didn't have typing).
        -->
      </ng-container>

      <hr class="my-2"/>

      <!-- If it's a user message, show normal text (or normal markdown) -->
      <ng-template #userMessage>
        <markdown [data]="msg.message"></markdown>
      </ng-template>
      <!-- <markdown class="table table-bordered table-striped"   [data]="msg.message"></markdown> -->
      <small>{{ msg.timestamp | date:'short' }}</small>

  <!-- Copy button for Assistant messages only -->
  <button
    *ngIf="msg.role.toString() === 'Assistant'"
    class="btn btn-sm btn-outline-secondary"
    style="border: none; margin-left: 5px; background: none;"


        (click)="copyToClipboard(msg.message)"
    aria-label="Copy assistant answer"
    ngbTooltip="Copy the response"


  >
  <i class="bi bi-clipboard"></i>  </button>
    </div>

    <div id="bottom"></div>
  </div>

  <!-- Chat Input & Buttons -->
  <div class="chat-input-container">
    <div class="chat-form">
      <div class="input-text-wrapper">
        <textarea
          class="input-message"
          [(ngModel)]="newMessage"
          rows="1"
          placeholder="Write a message..."
        ></textarea>
      </div>

      <div class="btn-group" role="group" aria-label="Chat actions">
        <!-- Send Button -->
        <button
          ngbTooltip="Ask (↵)"
          ngbDelay="1000"
          type="button"
          class=" btn btn-outline-primary btn-circle"
          style="border: none;"
          (click)="sendMessage()"
          [disabled]="isLoading"
          aria-label="Send message"

        >
          <i class="bi bi-send"></i>
        </button>

        <!-- Clear Button -->
        <button
          type="button"
          class="btn btn-outline-secondary btn-circle"
          style="border: none;"
          (click)="clearChat()"
          [disabled]="isLoading"
          aria-label="Clear chat"
           ngbTooltip ="Clear"
        >
          <i class="bi bi-trash"></i>
        </button>



      </div>
    </div>
  </div>
</div>
